import OrderPerson from './_order-person-card';
import ticketType from './_ticket-type';

(function(){
  if(!document.body.classList.contains('ticket')) return false;

  const form = document.querySelector('form');
  const mw_wp_form = document.querySelector('.mw_wp_form');
  const covers = document.querySelectorAll('.form-cover');
  const amount = document.querySelector('.amount input');
  const post_mails = document.querySelectorAll('input[name="事前郵送"]');

  //合計計算用
  document.ticket_types = [];

  post_mails.forEach((post_mail, i) => {
    post_mail.addEventListener('click', (e) => {
      ticketType.calqAmountTotal();
    })
  });

  covers.forEach((cover, i) => {

    const id = (i == 0 ? '' : i + 1);
    const add_button = cover.querySelector('.form-add-button');

    const checker = new OrderPerson({
      id: id,
      cover: cover
    });

    if(id != 9){
      add_button.addEventListener('click', function(e){
        const add_cover = covers[i+1];
        const require_items = [
          add_cover.querySelector('[name^=お名前]'),
          add_cover.querySelector('[name^=年]'),
          add_cover.querySelector('[name^=月]'),
          add_cover.querySelector('[name^=日]'),
          add_cover.querySelector('[name^=顔写真]'),
          add_cover.querySelector('[name^=チケット区分]')
        ]

        this.classList.add('confirm_show');
        add_cover.classList.remove('confirm_show');
        add_cover.classList.add('input_show');

        require_items.forEach((input, i) => {
          input.required = true;
        });

      });
    }

    if(id != ''){
      const add_button = covers[i-1].querySelector('.form-add-button');
      const inputs = cover.querySelectorAll('input[type="text"]');
      let is_show = false;
      inputs.forEach((input, i) => {
        if(is_show === true ) return;
        if(input.value != '') is_show = true;
      });
      if(is_show){
        add_button.click();
      }else{
        cover.classList.add('confirm_show');
      }
    }

    if(id == ''){
      if(location.host.match(/^kisofukushima\-ski\.lc/)) return;
      const require_items = [
        cover.querySelector('[name=都道府県]'),
        cover.querySelector('[name=市区町村・番地]'),
        cover.querySelector('[name=電話番号]'),
        cover.querySelector('[name=メールアドレス]'),
        cover.querySelector('[name=お支払い方法]'),
        cover.querySelector('[name=お名前]'),
        cover.querySelector('[name=年]'),
        cover.querySelector('[name=月]'),
        cover.querySelector('[name=日]'),
        cover.querySelector('[name=顔写真]'),
        cover.querySelector('[name=チケット区分]'),
        document.querySelector('[value="利用規約に同意する"]')
      ]
      require_items.forEach((input, i) => {
        input.required = true;
      });
      return;
    };

    const delete_button = cover.querySelector('.form-delete-button');
    delete_button.addEventListener('click', function(e){
      if(mw_wp_form.classList.contains('mw_wp_form_confirm')) false;
      const delete_cover = cover;
      const add_button = covers[i-1].querySelector('.form-add-button');
      const file_delete_button = delete_cover.querySelector('.mwform-file-delete');
      const inputs = delete_cover.querySelectorAll('[value]');
      const require_items = [
        delete_cover.querySelector('[name^=お名前]'),
        delete_cover.querySelector('[name^=年]'),
        delete_cover.querySelector('[name^=月]'),
        delete_cover.querySelector('[name^=日]'),
        delete_cover.querySelector('[name^=顔写真]'),
        delete_cover.querySelector('[name^=チケット区分]')
      ]
      add_button.classList.remove('confirm_show');
      delete_cover.classList.remove('input_show');
      delete_cover.classList.add('confirm_show');
      if(file_delete_button){
        file_delete_button.click();
      }
      inputs.forEach((input, i) => {
        if(input.type == 'radio' || input.type == 'checkbox'){
          input.checked = false;
        }else{
          input.value = '';
          input.value = '';
        }
      });
      require_items.forEach((input, i) => {
        input.required = false;
      });
      amount.value = ticketType.getAmountTotal().toLocaleString();
    });

  });

  //入力画面なら読み込み時に実行
  if(mw_wp_form.classList.contains('mw_wp_form_input')){
    ticketType.calqTicketTypeAll();
    amount.disabled = true;
    amount.value = ticketType.getAmountTotal().toLocaleString();
  }

})();
